import React, { useState, useEffect, useRef } from "react";
// import color1 from "../../assets/images/dummy/color1.png";
// import Y_Us_StripComponent from "../common/Y_us_strip";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
import { Button, Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  Stage,
  Layer,
  Text,
  Image as KonvaImage,
  Transformer,
  TextPath,
} from "react-konva";
// import "react-quill/dist/quill.snow.css";
// import Constants from "../Variables/Constants";
import axios from "axios";
import Konva from "konva";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./SvgCss/ColorChange.css";
import MainFabric from "./MainFabric";
import Fabric2 from "./Fabric2";
import Design from "./Design";
import CustomTextEditor from "./CustomTextEditor";
import "./ProductPage.css"
import Constants from "../App/Variables/Constants";
import "bootstrap-icons/font/bootstrap-icons.css";


const canvasWidth = 600;
const canvasHeight = 600;

const hexToRgb = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
};
const Rectangle = ({ shapeProps, isSelected, outlineBackground, onSelect, onChange, setBaseImageUrl }) => {
  const shapeRef = React.useRef();
  const [image, setImage] = React.useState(null);
  console.log("shapeProps", shapeProps);
  const baseImageUrl = shapeProps.src
  setBaseImageUrl(baseImageUrl)
  // Load the image dynamically
  React.useEffect(() => {
    const img = new window.Image();
    img.crossOrigin = "Anonymous";
    img.src = baseImageUrl; // Use the src from shapeProps
    img.onload = () => {
      setImage(img);
    };
  }, [baseImageUrl]);


  // Handle image deletion
  const handleDelete = (event) => {
    event.evt.stopPropagation(); // Stop event propagation to avoid selecting the image
    onChange({ ...shapeProps, delete: true }); // Signal deletion
  };

  // Calculate position for the cross icon
  const crossX = shapeProps.x + shapeProps.width - 25; // Position the cross at the top-right corner
  const crossY = shapeProps.y + 5; // Adjust vertical position

  // if (shapeRef.current && outlineBackground) {
  //   const konvaImage = shapeRef.current;
  //   konvaImage.cache(); // Cache image for better performance
  //   konvaImage.filters([Konva.Filters.RGBA]);
  //   const color = hexToRgb(outlineBackground);
  //   konvaImage.red(color.r);
  //   konvaImage.green(color.g);
  //   konvaImage.blue(color.b);
  //   konvaImage.draw(); // Redraw the image
  // }

  return (
    <React.Fragment>
      <KonvaImage
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        image={image}
        draggable={false}
      />

      {/* Delete icon */}
      <Text
        text="✖"
        fontSize={20}
        fill="red"
        x={crossX}
        y={crossY}
        onClick={handleDelete}
        onTap={handleDelete}
        draggable={false}
      />
    </React.Fragment>
  );
};

const ProductPage = () => {

  const [konvaImage1, setKonvaImage1] = useState(null); // Image for rendering in Konva

  const originalCanvasRef = useRef(null); // Hidden canvas to store the base image
  const modifiedCanvasRef = useRef(null); // Hidden canvas to store modified image data
  const HEX_COLOR = "#00FF00"; // Static hex color
  // #e7e8ea
  const [baseImageUrl, setBaseImageUrl] = useState("")
  const [fillImageUrl, setFillImageUrl] = useState("")

  const [activePill, setActivePill] = useState("Main Fabric");
  // use
  const [AllThread, setAllThread] = useState([]);
  const [allThreads, setAllThreads] = useState([]);
  const [getMainFabric, setAllMainFabric] = useState([]);
  const [getSecondaryFabric, setAllSecondaryFabric] = useState([]);
  const [getProducts, setProduct] = useState(null);
  const containerRef = useRef(null);

  // Canvas state
  const [bgColor, setBgColor] = useState(null);
  const [getFabricImage, setFabricImage] = useState([]);
  const [getFabric2Image, setFabric2Image] = useState([]);

  const [outlineBackground, setOutlineColor] = useState("");
  const initialRectangles = [];
  const [rectangles, setRectangles] = React.useState(initialRectangles);
  const [texts, setTexts] = React.useState([]);
  const [selectedId, selectShape] = React.useState(null);
  const [textInput, setTextInput] = React.useState("");
  const [selectedType, setSelectedType] = React.useState(null);
  const [selectedFont, setSelectedFont] = React.useState("Arial"); // Default font
  const [TextArea, setcloseTextArea] = React.useState(true);
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [categoryName, setCategoryName] = useState("");

  const [AllProductList, setProductList] = useState([]);

  const [Cart, setCartData] = useState("Add To Cart");
  const [mainFabricId, setMainFabricId] = useState("");
  const [Fabric2Id, setFabric2Id] = useState("");
  const [threadId, setThreadId] = useState("");
  const [designId, setDesignId] = useState([]);
  // const navigate = useNavigate();
  const stageRef = useRef(null); // Correctly initialize the ref
  const [selectedId1, setSelectedId1] = useState(null);
  const [textImageSrc, setTextImageSrc] = useState(null);
  // const [threadImage, setThreadImage] = useState(null);

  const [selectedTextImage, setSelectedTextImage] = useState(false);
  const [letterCount, setLetterCount] = useState(0);
  const textImageRef = useRef(null);
  const textTransformerRef = useRef(null);
  const [archObj, setArchObj] = useState(null);
  const [designImageId, setDesignImageId] = useState(null);
  const [currentDesign, setCurrentDesign] = useState(null);

  const location = useLocation();
  const editData = location.state?.designData;
  const [designData, setDesignData] = useState(editData ? editData : null);

  const hexToRgba = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
      a: 255,
    };
  };

  const handleImageProcessing = (baseImage, fillImage) => {
    if (!baseImage || !fillImage || !modifiedCanvasRef.current) return;

    const targetColor = hexToRgba(HEX_COLOR);

    const originalCanvas = originalCanvasRef.current;
    const modifiedCanvas = modifiedCanvasRef.current;

    originalCanvas.width = baseImage.width;
    originalCanvas.height = baseImage.height;
    modifiedCanvas.width = baseImage.width;
    modifiedCanvas.height = baseImage.height;

    const ctx = originalCanvas.getContext("2d");
    ctx.drawImage(baseImage, 0, 0);

    const modifiedCtx = modifiedCanvas.getContext("2d");
    modifiedCtx.drawImage(baseImage, 0, 0);

    const imageData = modifiedCtx.getImageData(0, 0, modifiedCanvas.width, modifiedCanvas.height);
    const pixels = imageData.data;

    const tolerance = 10;

    const isSimilarColor = (r1, g1, b1, r2, g2, b2, tol) => {
      return (
        Math.abs(r1 - r2) <= tol &&
        Math.abs(g1 - g2) <= tol &&
        Math.abs(b1 - b2) <= tol
      );
    };

    const floodFillWithImage = () => {
      const stack = [];
      const visited = new Set();

      for (let y = 0; y < modifiedCanvas.height; y++) {
        for (let x = 0; x < modifiedCanvas.width; x++) {
          const index = (y * modifiedCanvas.width + x) * 4;
          if (
            isSimilarColor(
              pixels[index],
              pixels[index + 1],
              pixels[index + 2],
              targetColor.r,
              targetColor.g,
              targetColor.b,
              tolerance
            )
          ) {
            stack.push([x, y]);
          }
        }
      }

      const fillCanvas = document.createElement("canvas");
      const aspectRatio = fillImage.width / fillImage.height;

      const scaledWidth = modifiedCanvas.width;
      const scaledHeight = scaledWidth / aspectRatio;
      fillCanvas.width = scaledWidth;
      fillCanvas.height = scaledHeight;

      const fillCtx = fillCanvas.getContext("2d");
      fillCtx.drawImage(fillImage, 0, 0, scaledWidth, scaledHeight);

      const fillData = fillCtx.getImageData(0, 0, scaledWidth, scaledHeight).data;

      while (stack.length > 0) {
        const [currentX, currentY] = stack.pop();

        const index = (currentY * modifiedCanvas.width + currentX) * 4;
        if (visited.has(index)) continue;
        visited.add(index);

        const fillX = Math.floor((currentX / modifiedCanvas.width) * scaledWidth);
        const fillY = Math.floor((currentY / modifiedCanvas.height) * scaledHeight);
        const fillIndex = (fillY * scaledWidth + fillX) * 4;

        pixels[index] = fillData[fillIndex];
        pixels[index + 1] = fillData[fillIndex + 1];
        pixels[index + 2] = fillData[fillIndex + 2];
        pixels[index + 3] = fillData[fillIndex + 3];
      }
    };

    floodFillWithImage();

    modifiedCtx.putImageData(imageData, 0, 0);

    const updatedImage = new window.Image();
    updatedImage.crossOrigin = "Anonymous";
    updatedImage.src = modifiedCanvas.toDataURL();
    updatedImage.onload = () => setKonvaImage1(updatedImage);
  };

  useEffect(() => {
    if (baseImageUrl && fillImageUrl) {

      const baseImage = new window.Image();
      const fillImage = new window.Image();

      baseImage.crossOrigin = "anonymous"; // Enable cross-origin for the base image
      fillImage.crossOrigin = "anonymous"; // Enable cross-origin for the fill image

      let baseImageLoaded = false;
      let fillImageLoaded = false;

      baseImage.src = baseImageUrl;
      fillImage.src = fillImageUrl;

      const checkImagesLoaded = () => {
        if (baseImageLoaded && fillImageLoaded) {
          handleImageProcessing(baseImage, fillImage);
        }
      };

      baseImage.onload = () => {
        baseImageLoaded = true;
        checkImagesLoaded();
      };

      fillImage.onload = () => {
        fillImageLoaded = true;
        checkImagesLoaded();
      };
    }
  }, [baseImageUrl, fillImageUrl]);

  const convertToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    } catch (error) {
      console.error("Error converting to Base64:", error);
      return null; // Return null in case of error
    }
  };

  useEffect(() => {
    if (designData) {
      const fetchBase64 = async () => {
        if (designData) {

          if (designData?.konvaImage1) {
            const konvaBase64 = await convertToBase64(Constants.imgDomain + designData.konvaImage1);
            designData.design_data.images.konvaImage1 = konvaBase64;
          }

          if (designData?.textImage) {
            const textBase64 = await convertToBase64(Constants.imgDomain + designData.textImage);
            designData.design_data.images.textImage = textBase64;
          }

          loadDesign(designData.design_data);


        }
      };

      fetchBase64()
    }
  }, [designData])

  const getAllFabric = () => {
    axios
      .get(`${Constants.getUrls.getFabrics}?limit=${100}`)
      .then((resp) => {
        if (resp.data.status === "success") {
          setAllMainFabric(resp.data.groupedFabrics);
          setAllSecondaryFabric(resp.data.groupedFabrics);
        }
      })
      .catch((error) => {
        console.error("Error in stylesChange:", error);
      });
  };



  const getAllThreads = () => {
    axios
      .get(`${Constants.getUrls.getAllThread}?limit=${100}&status=active`)
      .then((resp) => {
        if (resp.data.status === "success") {
          if (resp.data.data.docs.length > 0) {
            setAllThreads(resp.data.data.docs);
          }
        }
      })
      .catch((error) => {
        console.error("Error in stylesChange:", error);
      });
  };
  const getSingleProduct = (id) => {
    axios
      .get(Constants.getUrls.getProduct + "/" + id)
      .then((resp) => {
        if (resp.data.status === "success") {
          if (resp.data.data) {
            if (resp.data.data.cart_item) {
              setCartData("Go To Cart");
            }
            setCategoryId(resp.data.data.category);
            setSubCategoryId(resp.data.data.sub_category);
            setProduct(resp.data.data);
            
            // Fetch category name
            if (resp.data.data.category) {
              fetchCategoryName(resp.data.data.category);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error in stylesChange:", error);
      });
  };

  const fetchCategoryName = (categoryId) => {
    axios
      .get(`${Constants.getUrls.getAllCategory}?limit=1&categoryId=${categoryId}`)
      .then((resp) => {
        if (resp.data.status === "success" && resp.data.data.docs.length > 0) {
          setCategoryName(resp.data.data.docs[0].name);
        }
      })
      .catch((error) => {
        console.error("Error fetching category name:", error);
      });
  };

  const getAllProducts = () => {
    axios
      .get(
        `${Constants.getUrls.getProductList
        }?limit=${100}&category=${categoryId}&sub_category=${subCategoryId}`
      )
      .then((resp) => {
        if (resp.data.status === "success") {
          setProductList(resp.data.data.docs);
        }
      })
      .catch((error) => {
        console.error("Error in stylesChange:", error);
      });
  };

  const handlePillClick = (pillName) => {
    if (pillName !== "Personalize") {
      // setShowPopup(false);
      setcloseTextArea(false);
    }

    switch (pillName) {
      case "Main Fabric":
        setActivePill(pillName);
        break;

      case "Design":
        getFabricImage.length === 0
          ? showAlert("Main Fabric")
          : setActivePill(pillName);
        break;

      case "Fabric 2":
        rectangles.length === 0 ? showAlert("Design") : setActivePill(pillName);
        break;

      case "Personalize":
        setActivePill(pillName);
        break;

      case "Thread Color":
        rectangles.length === 0 ? showAlert("Design") : setActivePill(pillName);
        break;

      case "Reset":
        setFabricImage([]);
        setFabric2Image([]);
        setRectangles([]);
        setTexts([]);
        setBgColor(null);
        getSingleProduct();
        setActivePill("Main Fabric");
        setTextInput('');
        setTextImageSrc(null);
        setLetterCount(0);
        setMainFabricId([])
        setFabric2Id("")
        setThreadId("")
        // setMainFabricColor("");
        setDesignId([])
        setBaseImageUrl("")
        setFillImageUrl("")
        setKonvaImage1(null)
        setOutlineColor("")
        setDesignImageId(null)
        setCurrentDesign(null)
        setArchObj(null)
        break;
      default:
        break;
    }
  };

  const showAlert = (text) => {
    toast.error(`Please select ${text}!`);
  };


  console.log("rectangles", rectangles);
  // const outLineChange = (color, id) => {
  const outLineChange = (prop) => {

    setDesignImageId(prop.id);
    const { color, id, image } = prop;
    // setMainFabricColor(color);
    const colorStr = String(color);
    const foundColor = allThreads.find((color) => color.color_code.toLowerCase() === colorStr.toLowerCase());
    if (foundColor) {
      setThreadId(foundColor._id);
    } else {
      setThreadId("");
    }
    // setThreadImage(image);
    setOutlineColor(color);
    setKonvaImage1(null);
    setFillImageUrl("");
    setFabric2Image([]);
    setFabric2Id("");

    rectangles.forEach((rectangle) => {
      rectangle.src = `${Constants.imgDomain}${image}`
    });
  };

  const ExploreProductsOptions = {
    navText: [
      "<i className='bi bi-chevron-left'><</i>",
      "<i className='bi bi-chevron-right'>></i>",
    ],
    autoplay: true,
    items: 2,
    loop: true,
    nav: true,
    dots: false,
    responsive: {
      1: {
        items: 1,
        margin: 10,
      },
      450: {
        items: 2,
        margin: 10,
      },
      600: {
        items: 2,
        margin: 10,
      },
      750: {
        items: 3,
        margin: 10,
      },
      1000: {
        items: 3,
        margin: 15,
      },
      1225: {
        items: 4,
        margin: 20,
      },
      1300: {
        items: 4,
        margin: 30,
      },
      1500: {
        items: 5,
        margin: 30,
      },
    },
  };

  const handleSelect = (id) => {
    setSelectedId1(id);
  };
  const checkDeselect = (e) => {

    if (e.target === e.target.getStage()) {
      setSelectedId1(null);
      // setSelectedShape(null);
    }

    const isStageClick = e.target === e.target.getStage(); // If clicked on the stage
    const isEmptyAreaClick =
      e.target instanceof Konva.Layer || e.target instanceof Konva.Stage;
    const isSelectable = e.target.attrs && e.target.attrs.selectable; // Check if the clicked object is selectable

    if (!isSelectable && (isStageClick || isEmptyAreaClick)) {
      selectShape(null); // Deselect any selected shape
      setSelectedType(null);
      setcloseTextArea(false);

      setTextInput("");
    }
  };


  const closeTextArea = () => {
    setcloseTextArea(true);
  };
  const handleEditText = (text, index, color) => {
    setTextInput(text); // Set the text for editing
  };

  useEffect(() => {
    getSingleProduct(window.location.pathname.split("/")[2]);
    getAllProducts();

    getAllFabric();
    getAllThreads();
  }, []);

  useEffect(() => {
    setFabricImage([]);
    setRectangles([]);
    setTexts([]);
    setBgColor(null);
    setActivePill("Main Fabric");
    getSingleProduct(window.location.pathname.split("/")[2]);
  }, [window.location.pathname.split("/")[2]]);

  React.useEffect(() => {
    if (selectedTextImage && textTransformerRef.current && textImageRef.current) {
      textTransformerRef.current.nodes([textImageRef.current]);
      textTransformerRef.current.getLayer().batchDraw();
    }
  }, [selectedTextImage]);

  const removeExistingCustomization = async () => {
    const result = await axios.get(Constants.getUrls.getAdminCustomizedImage + `/${window.location.pathname.split("/")[2]}`);

    if (result.data.data.length > 0) {
      await axios.delete(Constants.deleteUrls.removeCustomizedImage + `/${result.data.data[0]._id}`, {
        headers: {
          Authorization: localStorage.getItem("accessToken"),
        },
      });
    }
  }

  // Select Custom Image Function
  const handleExportImage = async () => {
    if (stageRef.current) {

      await removeExistingCustomization();

      const dataURL = stageRef.current.toDataURL();
      const blob = await (await fetch(dataURL)).blob();
      const formData = new FormData();
      formData.append("file", blob, `customizedImg-${Date.now()}.png`);
      formData.append("main_fabric_id", mainFabricId);
      formData.append("accent_color_id", Fabric2Id);
      formData.append("letter_count", letterCount);
      formData.append("product_id", window.location.pathname.split("/")[2]);
      formData.append("admin_customization", "yes")

      console.log(designImageId, "designImageId");
      console.log(currentDesign, "currentDesign")

      if (!designImageId && currentDesign) {
        const data = currentDesign.images.find((image) => image.is_main === 1);
        formData.append("design_image_id", data.id);
      } else if (designImageId) {
        formData.append("design_image_id", designImageId);
      }

      const designData = await saveDesign();

      if (designData) {
        formData.append("design_data", JSON.stringify(designData));
      }

      if (designData?.images?.konvaImage1) {
        formData.append("konvaImage1", designData.images.konvaImage1, `konvaImage1-${Date.now()}.png`);
      }

      if (designData?.images?.textImage) {
        formData.append("textImage", designData.images.textImage, `textImage-${Date.now()}.png`);
      }

      axios
        .post(Constants.postUrls.uploadCustomizedImage, formData, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.status === 200) {
            console.log(response)
            toast.success("Image added successfully!",
              {
                style: { backgroundColor: "green", color: "white" },
              }
            );
          }
        })
        .catch((error) => {
          console.error("Error exporting image:", error);
        });
    } else {
      toast.warning("Please Customize Product!");
    }
  };

  const saveDesign = async () => {
    const stage = stageRef.current.getStage();

    const konvaImage1Blob = await (await fetch(konvaImage1?.src)).blob();
    const textImageSrcBlob = await (await fetch(textImageSrc?.src)).blob();

    const designData = {
      rectangles: rectangles.map(rect => ({
        id: rect.id,
        x: rect.x,
        y: rect.y,
        src: rect.src,
        width: rect.width,
        height: rect.height,
        type: rect.type
      })),

      images: {
        konvaImage1: konvaImage1Blob,
        textImage: textImageSrcBlob,
        fabricImages: getFabricImage.map(img => ({
          src: img.image.src,
          position: { x: img.x, y: img.y },
          size: { width: img.width, height: img.height }
        })),
        getFabric2Image: getFabric2Image.map(img => ({
          src: img.image.src,
          position: { x: img.x, y: img.y },
          size: { width: img.width, height: img.height }
        })),
      },

      transforms: {
        selectedTextImage: textTransformerRef.current?.nodes()[0]?.attrs || null
      },

      mainFabricId: mainFabricId,
      designId: designId,
      baseImageUrl: baseImageUrl,
      fillImageUrl: fillImageUrl,
      outlineBackground: outlineBackground,
      selectedId: selectedId,
      currentDesign: currentDesign,
      textInput: textInput,
      archObj: archObj,
      letterCount: letterCount
    };


    // Save to localStorage or send to backend
    localStorage.setItem('savedDesign', JSON.stringify(designData));

    return designData;

  };

  const loadDesign = async (savedData) => {
    // const savedData = JSON.parse(localStorage.getItem('savedDesign'));
    console.log("Loaded Data:", savedData); // Debugging

    if (savedData) {
      // Load fabric images
      const loadedImages = await Promise.all(
        savedData.images.fabricImages.map(imgData => {
          return new Promise((resolve) => {
            const image = new Image();
            image.src = imgData.src;
            image.crossOrigin = "Anonymous";
            image.onload = () => {
              resolve({
                image: image,
                x: imgData.position.x,
                y: imgData.position.y,
                width: imgData.size.width,
                height: imgData.size.height
              });
            };
          });
        })
      );

      const loadedFabric2Images = await Promise.all(
        savedData.images.getFabric2Image.map(imgData => {
          return new Promise((resolve) => {
            const image = new Image();
            image.src = imgData.src;
            image.crossOrigin = "Anonymous";
            image.onload = () => {
              resolve({
                image: image,
                x: imgData.position.x,
                y: imgData.position.y,
                width: imgData.size.width,
                height: imgData.size.height
              });
            };
          });
        })
      );

      // Update state
      setRectangles(savedData.rectangles);
      // setTexts(savedData.texts);
      setFabricImage(loadedImages);
      setFabric2Image(loadedFabric2Images);
      setMainFabricId(savedData.mainFabricId);
      setBgColor("white")
      setDesignId(savedData.designId)
      setBaseImageUrl(savedData.baseImageUrl)
      setFillImageUrl(savedData.fillImageUrl)
      // setAllThreads(savedData.allThreads)
      setOutlineColor(savedData.outlineBackground)
      setSelectedId1(savedData.selectedId)
      setCurrentDesign(savedData.currentDesign)
      setAllThread(savedData.currentDesign)
      setTextInput(savedData.textInput)
      setArchObj(savedData.archObj)
      setLetterCount(savedData.letterCount)

      // Load konvaImage1
      if (savedData.images.konvaImage1) {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = savedData.images.konvaImage1;
        img.onload = () => setKonvaImage1(img);
      }

      // Load textImageSrc
      if (savedData.images.textImage) {
        const textImg = new Image();
        textImg.crossOrigin = "Anonymous";
        textImg.src = savedData.images.textImage;
        textImg.onload = () => setTextImageSrc(textImg);
      }

      // Apply transforms after render
      setTimeout(() => {
        if (savedData.transforms.selectedTextImage && textTransformerRef.current) {
          textImageRef.current.setAttrs(savedData.transforms.selectedTextImage);
          textTransformerRef.current.nodes([textImageRef.current]);
          textTransformerRef.current.forceUpdate();
        }
      }, 100);
    }
  };


  return (
    <div className="product" style={{ background: "#e1e8e7", minHeight: "100vh" }}>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="container-fluid px-5 py-5">
        <div className="row g-5">
          <div className="col-xl-6 col-lg-12 col-12">
            <div className="d-flex flex-column mt-3 align-items-center justify-content-center gap-3">

              {bgColor == null ? (
                <img
                  src={
                    getProducts
                      ? Constants.imgDomain + getProducts.images[0]
                      : ""
                  }
                  className="p-5 img-fluid proImg2"
                  alt="banner-1"
                // style={{}}
                />
              ) : (
                <div className="my-2">
                  <Stage
                    width={canvasWidth}
                    height={canvasHeight}
                    ref={stageRef}
                    onMouseDown={checkDeselect}
                    onTouchStart={checkDeselect}
                  >
                    <Layer>

                      {getFabricImage.map((img) => (
                        <React.Fragment key={img.id}>
                          <KonvaImage
                            key={img.id}
                            image={img.image}
                            x={img.x}
                            y={img.y}
                            draggable={false}
                            width={img.width}
                            height={img.height}
                          />
                        </React.Fragment>
                      ))}

                      {!konvaImage1 && (<>
                        {getFabric2Image.map((img) => {
                          const correspondingRect = rectangles.find((rect) => rect.type == 'art1'); // Match fabric2 image with rectangle by id
                          if (correspondingRect) {
                            return (<>
                              <KonvaImage
                                key={img.id}
                                image={img.image}
                                x={0 + (canvasWidth / 2) - ((correspondingRect.width / 2) / 2)}
                                y={0 + (canvasHeight / 2) - ((correspondingRect.height / 2) / 2)}
                                width={correspondingRect.width / 2} // Adjust size as needed
                                height={correspondingRect.height / 2}  // Use the same height as the rectangle
                                draggable={false}
                                ref={img.ref}
                                onClick={() => handleSelect(img.id)}
                                onTap={() => handleSelect(img.id)}
                              />
                              {selectedId1 === img.id && (
                                <Transformer
                                  nodes={[img.ref.current]}
                                  boundBoxFunc={(oldBox, newBox) => {
                                    if (newBox.width < 50 || newBox.height < 50) {
                                      return oldBox;
                                    }
                                    return newBox;
                                  }}
                                />
                              )}
                            </>);
                          }
                          return null;
                        })}


                        {console.log('0----rectangles', rectangles)}
                        {/* Display cropped image if available */}
                        {rectangles.map((rect, i) => {
                          return (
                            <Rectangle
                              key={rect.id}
                              backgroundColor={"red"}
                              outlineBackground={outlineBackground}
                              setBaseImageUrl={setBaseImageUrl}
                              shapeProps={{
                                ...rect,
                                width: rect.width,  // Apply width scaling
                                height: rect.height,  // Apply height scaling
                              }}
                              isSelected={rect.id === selectedId}
                              onSelect={() => {
                                selectShape(rect.id); // Select shape logic
                                const updatedRectangles = rectangles.slice();
                                updatedRectangles[i] = {
                                  ...updatedRectangles[i],
                                  width: rect.width,
                                  height: rect.height,
                                };
                                setRectangles(updatedRectangles); // Update rectangle size
                              }}

                              onChange={(newAttrs) => {
                                if (newAttrs.delete) {
                                  // Delete the rectangle logic
                                  const newRectangles = rectangles.filter((r) => r.id !== rect.id);
                                  setRectangles(newRectangles);
                                } else {
                                  // Update rectangle attributes
                                  const updatedRectangles = rectangles.slice();
                                  updatedRectangles[i] = newAttrs;
                                  setRectangles(updatedRectangles);
                                }
                              }}
                            />
                          );
                        })}

                      </>)}
                      {konvaImage1 && (<>
                        <KonvaImage
                          image={konvaImage1}
                          width={canvasWidth}
                          height={canvasHeight}
                        />
                      </>)}

                      {(textImageSrc && !archObj) ? (<>
                        <KonvaImage
                          x={(canvasWidth - textImageSrc.width) / 2}
                          y={(canvasHeight - textImageSrc.height) / 2}
                          image={textImageSrc}
                          draggable={true}
                          ref={textImageRef}
                          onClick={() => setSelectedTextImage(!selectedTextImage)}
                        />
                        {selectedTextImage && (
                          <Transformer
                            ref={textTransformerRef}
                            rotateEnabled={true}
                          />
                        )}
                      </>) : null}
                      {archObj && textImageSrc ?
                        <>
                          <TextPath
                            // x={(canvasWidth - textImageSrc.width)/2}
                            // y={(canvasHeight - textImageSrc.height)/2}
                            x={150}
                            y={150}
                            text={archObj.text}
                            fontSize={16}
                            fontFamily={archObj.font}
                            fill={archObj.color}
                            draggable={true}
                            ref={textImageRef}
                            data={`
                              M 100,100
                              A 100,100 0 1,1 300,100
                            `}
                            onClick={() => setSelectedTextImage(!selectedTextImage)}
                          />
                          {selectedTextImage && (
                            <Transformer
                              ref={textTransformerRef}
                              rotateEnabled={true}
                              keepRatio={true}
                            />
                          )}
                        </> : null
                      }
                    </Layer>
                  </Stage>
                </div>
              )}

            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-12">
            <ul className="nav nav-pills gap-4 flex-wrap">
              <li className="nav-item">
                <a
                  className={`nav-link fs-16 ${activePill === "Main Fabric" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => handlePillClick("Main Fabric")}
                >
                  Main Fabric
                </a>
              </li>

              <li className="nav-item">
                <a
                  className={`nav-link fs-16 ${activePill === "Design" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => handlePillClick("Design")}
                >
                  Design
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link fs-16 ${activePill === "Fabric 2" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => handlePillClick("Fabric 2")}
                >
                  Accent Color
                </a>
              </li>

              <li className="nav-item">
                <a
                  className={`nav-link fs-16 ${activePill === "Personalize" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => {
                    handlePillClick("Personalize");
                    // setShowPopup(true);
                    closeTextArea();
                  }}
                >
                  Personalize
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link fs-16 ${activePill === "Thread Color" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => handlePillClick("Thread Color")}
                >
                  Thread Color
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link fs-16 ${activePill === "Reset" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => handlePillClick("Reset")}
                >
                  Reset
                </a>
              </li>
            </ul>

            {activePill === "Main Fabric" ? (
              <MainFabric
                getMainFabric={getMainFabric}
                setMainFabricId={setMainFabricId}
                mainFabricId={mainFabricId}
                setBgColor={setBgColor}
                setFabricImage={setFabricImage}
                canvasWidth={canvasWidth}
                canvasHeight={canvasHeight}
              />
            ) : (
              ""
            )}
            {activePill === "Fabric 2" ? (
              <Fabric2
                getSecondaryFabric={getSecondaryFabric}
                setFabric2Id={setFabric2Id}
                Fabric2Id={Fabric2Id}
                setFabric2Image={setFabric2Image}
                setRectangles={setRectangles}
                rectangles={rectangles}
                setFillImageUrl={setFillImageUrl}
              />
            ) : (
              ""
            )}
            {activePill === "Personalize" && TextArea ? (
              <CustomTextEditor
                setLetterCount={setLetterCount}
                setTextInput={setTextInput}
                containerRef={containerRef}
                setTextImageSrc={setTextImageSrc}
                textInput={textInput}
                setArchObj={setArchObj}
              />
            ) : (
              ""
            )}

            {activePill === "Design" ? (
              <Design
                setKonvaImage1={setKonvaImage1}
                setFillImageUrl={setFillImageUrl}
                setFabric2Image={setFabric2Image}
                designId={designId}
                product={getProducts}
                setDesignId={setDesignId}
                setRectangles={setRectangles}
                setFabric2Id={setFabric2Id}
                setAllThread={setAllThread}
                setCurrentDesign={setCurrentDesign}
              />
            ) : (
              ""
            )}
            {console.log('------AllThread', AllThread)}
            {activePill === "Thread Color" ? (
              <div
                className="row flex-column border border-3 border-dark overflow-hidden rounded-5 my-3"

              >
                <div className="col-12" >
                  <div className="row flex-column gap-4" style={{ backgroundColor: "white" }}>
                    <div className=" fabricCon overflow-y-scroll overflow-x-hidden">
                      <div className="d-flex justify-content-between">
                        <h5 style={{ color: "black" }}>Thread Color</h5>
                        <i className="bi bi-x fs-26 "></i>
                      </div>
                      <div className="d-flex flex-wrap gap-2 ">
                        <div className="colors">
                          {AllThread && AllThread.images && AllThread.images.length > 0 ? (
                            AllThread.images.map((image, idx) => (
                              <div
                                key={idx}
                                className={`color-circle ${outlineBackground === image.color ? "selected" : ""
                                  }`}
                                style={{ backgroundColor: image.color }}
                                onClick={() => {
                                  outLineChange(image)
                                }}
                              />
                            ))
                          ) : (
                            <div>No colors available</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="d-flex gap-2 justify-content-center">
              <button onClick={handleExportImage} className="btn w-100 btn-primary bg-dark-blue fs-18 text-white" style={{ marginTop: "80px" }}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        ref={containerRef}
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          width: 'auto',
        }}
        dangerouslySetInnerHTML={{ __html: textInput }}
      />


      <canvas ref={originalCanvasRef} style={{ display: "none" }} />
      <canvas ref={modifiedCanvasRef} style={{ display: "none" }} />
    </div>
  );
};

export default ProductPage;
